<template>
  <CoreDrawer
    :value="isDialogOpened"
    :title="t('Фильтры', options)"
    attach=".vue-the-lpu-filters .v-application"
    @input="handleCloseLpuFilters"
  >
    <template #default>
      <ListItemLpuType
        v-model="lpuFiltersState"
        class="my-2"
      />
      <ListItemDoctorSpeciality
        v-model="lpuFiltersState"
        class="my-2"
      />
      <ListItemPlace
        v-model="lpuFiltersState"
        class="my-2"
      />
      <ListItemTimeWork
        v-model="lpuFiltersState"
        class="my-2"
      />
      <SwitchHighRating
        v-model="lpuFiltersState"
        class="mb-2"
      />
      <SwitchAppointment
        v-model="lpuFiltersState"
        class="mb-2"
      />
      <SwitchClub
        v-if="!isYDoc"
        v-model="lpuFiltersState"
      />
      <v-divider class="my-4" />
      <ListItemLpuSort
        v-model="lpuFiltersState"
      />
    </template>
    <template #footer>
      <BtnApplyFilters
        :active="isDialogOpened"
        class="pa-2 elevation-8"
        :trigger-request="triggerUpdateLpuCount"
        @click:submit="applyLpuFilters"
        @click:close="handleCloseLpuFilters"
      />
    </template>
  </CoreDrawer>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import I18NextVue from 'i18next'
import CoreDrawer from 'src/core/CoreDrawer/CoreDrawer.vue'
import ListItemPlace from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemPlace/ListItemPlace.vue'
import ListItemLpuSort from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemLpuSort/ListItemLpuSort.vue'
import ListItemLpuType from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemLpuType/ListItemLpuType.vue'
import ListItemTimeWork from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemTimeWork/ListItemTimeWork.vue'
import ListItemDoctorSpeciality from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/ListItemDoctorSpeciality/ListItemDoctorSpeciality.vue'
import SwitchClub from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchClub/SwitchClub.vue'
import SwitchHighRating from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchHighRating/SwitchHighRating.vue'
import SwitchAppointment from 'www/vue_components/common/TheFilters/lpu/components/LpuFilters/components/SwitchAppointment/SwitchAppointment.vue'
import BtnApplyFilters from 'www/vue_components/common/TheFilters/lpu/components/BtnApplyFilters/BtnApplyFilters.vue'
import useChipsStore from 'www/vue_components/common/TheFilters/lpu/stores/useChipsStore'
import useCommonStore from 'www/vue_components/common/TheFilters/lpu/stores/useCommonStore'
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import deepClone from 'www/vue_components/common/TheFilters/lpu/functions/deepClone'
import updateLpuListPage from 'www/vue_components/common/TheFilters/lpu/functions/updateLpuListPage'

const isYDoc = window.IS_YDOC

const chipsStore = useChipsStore()
const commonStore = useCommonStore()
const filtersStore = useFiltersStore()

const { t, language } = I18NextVue
const options = { ns: language }

const { isDialogOpened, openDialog, closeDialog } = useDialogManager('LpuFilters')

const lpuFiltersState = ref(deepClone(filtersStore.filters))

const resetLpuFiltersState = () => {
  lpuFiltersState.value = deepClone(filtersStore.filters)
  filtersStore.resetUnsavedFilters()
}

watch(() => isDialogOpened.value, resetLpuFiltersState)

const triggerUpdateLpuCount = ref(false)
const updateLpuCount = () => {
  triggerUpdateLpuCount.value = !triggerUpdateLpuCount.value
}

watch(lpuFiltersState, updateLpuCount, { deep: true })

const hasAppliedFilters = computed(() => Boolean(
  filtersStore.filters.place
  || filtersStore.filters.sort
  || filtersStore.filters.lpuType
  || filtersStore.filters.doctorSpeciality
  || filtersStore.filters.isHighRating
  || filtersStore.filters.isOnlineAppointment
  || filtersStore.filters.isClubAppointment
  || filtersStore.filters.timeWork.type !== 'any',
))

watch(
  () => hasAppliedFilters.value,
  () => {
    chipsStore.updateMenuChip({
      isActive: hasAppliedFilters.value,
      isVisible: true,
      onClick: openDialog,
    })
  },
  { immediate: true },
)

const handleCloseLpuFilters = () => {
  closeDialog()

  filtersStore.resetUnsavedFilters()
}

const applyLpuFilters = async () => {
  closeDialog()

  if (
    filtersStore.unsavedFilters.place?.isMetro
    && filtersStore.unsavedFilters.place.id !== filtersStore.filters.place?.id
  ) {
    commonStore.updateTownToRegionalCenter()
  } else {
    commonStore.updateTownToReferrer()
  }

  filtersStore.applyUnsavedFilters()

  await updateLpuListPage()
}
</script>
